import React from "react";
import _ from "underscore";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { productPropType, reservationPropType } from "../../propTypes";
import ClosableModal from "components/source/shared/closable-modal";
import DatepickerWithZipAndDuration from "components/source/shared/calendars/datepicker-with-zip-and-duration";
import AtomFullWidthButton from "components/source/atoms/atom-full-width-button";
import { compose } from "redux";
import { withPersistedFilters } from "../hoc/with-persisted-filters";

const propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  errors: PropTypes.object,
  modalShowing: PropTypes.bool.isRequired,
  duration: PropTypes.number,
  date: PropTypes.string,
  zipCode: PropTypes.string,
  dateOptions: PropTypes.object.isRequired,
  deliveryCutoffs: PropTypes.array,
  updateReservation: PropTypes.func.isRequired,
  onChangeReservationInput: PropTypes.func.isRequired,
  dateInputName: PropTypes.string,
  durationInputName: PropTypes.string,
  product: productPropType,
  reservation: reservationPropType,
  writePreferences: PropTypes.func.isRequired,
  zipInputName: PropTypes.string,
};

const defaultProps = {
  onCloseModal: () => {},
};

class DateZipModal extends React.Component {
  constructor(props) {
    super(props);
    this.className = "date-zip-modal";
    this.state = {
      zipCodeIsValid: null,
      hasClickedApply: false,
      initialDate: props.date,
      initialDuration: props.duration,
      initialZipCode: props.zipCode,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // The reservation is loaded async, so we might receive date/zip/duration after the
    // component has mounted. In that case, let's update the state
    // If we've already set the state to reflect the initial props, don't set it again
    if (this?.state?.initialDate || this?.state?.initialZipCode || this?.state?.initialDuration) {
      return;
    }

    // We want to save the initial state so that when the user clicks "close", we can
    // return the reservation fields back to what they were before they opened the modal
    this.setState({
      initialDate: nextProps.date,
      initialDuration: nextProps.duration,
      initialZipCode: nextProps.zipCode,
    });
  }

  updateZipValidity = valid => {
    this.setState({ zipCodeIsValid: valid });
  };

  submitFilters(filters) {
    const newFilters = {
      ...filters,
    };
    this.props.writePreferences(newFilters);
  }

  submitAndClose = () => {
    this.setState({ hasClickedApply: true });

    const updatedFilters = {
      date: this.props.date,
      duration: this.props.duration,
      zip_code: this.props.zipCode,
    };

    this.submitFilters(updatedFilters);

    if (!_.isEmpty(this.getErrors(true))) {
      return;
    }

    this.handleCloseModal();
  };

  handleCloseModal = () => {
    this.props.onCloseModal();
  };

  cancelReservationChanges = () => {
    this.props.updateReservation({
      date: this.state.initialDate,
      duration: this.state.initialDuration,
      zipCode: this.state.initialZipCode,
    });

    this.handleCloseModal();
  };

  getErrors(submitting) {
    // we only care about date, duration and zipcode errors from the error props
    const { date, duration, zipCode } = this.props?.errors?.reservation ?? {},
      errors = _.omit({ date, duration, zipCode }, function (error) {
        return !error;
      }); // the object shouldn't have any undefined or null values
    if (!submitting && !this.state.hasClickedApply) {
      return errors;
    }

    const requiredFieldErrors = {};
    if (!this.props.date) {
      requiredFieldErrors["date"] = "Please select a date";
    }
    if (!this.props.zipCode) {
      requiredFieldErrors["zipCode"] = "Please enter a zip code";
    }
    if (!this.state.zipCodeIsValid) {
      requiredFieldErrors["zipCode"] = "Please enter a valid zip code";
    }

    return Object.assign(errors, requiredFieldErrors);
  }

  render() {
    return (
      <ClosableModal
        isOpen={this.props.modalShowing}
        optionalClass={this.className}
        onRequestClose={this.cancelReservationChanges}>
        <DatepickerWithZipAndDuration
          errors={this.getErrors()}
          duration={this.props.duration}
          date={this.props.date}
          zipCode={this.props.zipCode}
          dateOptions={this.props.dateOptions}
          deliveryCutoffs={this.props.deliveryCutoffs}
          onChange={this.props.onChangeReservationInput}
          updateZipValidity={this.updateZipValidity}
          dateInputName={this.props.dateInputName}
          durationInputName={this.props.durationInputName}
          product={this.props.product}
          reservation={this.props.reservation}
          zipInputName={this.props.zipInputName}
        />

        <AtomFullWidthButton onClick={this.submitAndClose} buttonText="Apply" />
      </ClosableModal>
    );
  }
}

const mapStateToProps = state => {
  return {
    product: state.product,
    reservation: state.reservation,
  };
};

export default compose(withPersistedFilters, connect(mapStateToProps))(DateZipModal);

DateZipModal.propTypes = propTypes;
DateZipModal.defaultProps = defaultProps;
